export default "__VITE_ASSET__CMFsUneP__"